import { BarList, DonutChart, formatMoney, formatNumber } from '@platform/design-system';
import { usePageContext } from '../../usePageContext.ts';
import { seriesUnitOfRange } from '../../report-period.ts';
import { topProductSlicesOf } from '../top-product-slices.ts';
import { usePerformanceFor } from './widget-queries.ts';
import type { WidgetProps } from './widget-props.ts';
import { WidgetBody } from './WidgetBody.tsx';

export const TopProductsWidget = ({ widget, context }: WidgetProps<'topProducts'>) => {
  const { t, locale } = usePageContext();
  const { rankedBy, size, chart } = widget.settings;
  const performance = usePerformanceFor(context, {
    unit: seriesUnitOfRange(context.range),
    topProducts: { rankedBy, size },
  });
  const report = performance.data;
  const items =
    report === undefined
      ? []
      : topProductSlicesOf(report.topProducts, rankedBy, {
          units: (units) =>
            t('dashboard.overview.unitsSold', { count: units, total: formatNumber(units, locale) }),
          amount: (amount) => formatMoney({ amount, currency: report.currency }, locale),
        });
  const props = {
    label: t(`dashboard.overview.rankTitle.${rankedBy}`),
    emptyTitle: t('dashboard.noSales'),
    loading: performance.isPending,
  };
  return (
    <WidgetBody query={performance}>
      {chart === 'donut' ? <DonutChart {...props} slices={items} /> : <BarList {...props} items={items} />}
    </WidgetBody>
  );
};
